import SectionHeading from '@/components/feature/SectionHeading';
import { testimonials } from '@/mocks/testimonials';
import type { Testimonial } from '@/types/content';

const list = testimonials as Testimonial[];

export default function TestimonialSection() {
  return (
    <section id="reviews" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionHeading
          eyebrow="Reviews"
          title="读者怎么说"
          desc="我们更希望被当成一个「帮你省时间」的追更工具，而不是又一个刷不完的信息流。以下评价来自长期订阅读者的反馈整理。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {list.map((t) => (
            <figure
              key={t.name}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300 mb-3" aria-hidden="true"></i>
              <blockquote className="text-sm text-foreground-700 leading-7 flex-1">{t.text}</blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
                <span className="w-9 h-9 rounded-full bg-secondary-100 text-secondary-700 flex items-center justify-center font-heading font-bold text-sm">
                  {t.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-950">{t.name}</span>
                  <span className="block text-[11px] text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}